import {createMapStore} from '@repo/shared-web/lib/map_data_store';

const subtitleDownloadLinkStore = createMapStore<number, string>();

export const useAllSubtitleDownloadLink = subtitleDownloadLinkStore.useAllData;
export const useSubtitleDownloadLink = subtitleDownloadLinkStore.useData;
export const setSubtitleDownloadLink = subtitleDownloadLinkStore.setData;
